import { ConfigStateService, getShortDateFormat } from '@abp/ng.core';
import { Component, Input } from '@angular/core';
import { AssetDetailsDto, AssetService, AssetType } from '@proxy/register-service/assets';

@Component({
  selector: 'app-asset-avatar',
  templateUrl: './asset-avatar.component.html',
  styleUrls: ['./asset-avatar.component.scss'],
})
export class AssetAvatarComponent {
  @Input() asset: AssetDetailsDto;
  @Input() isPageTemporary: boolean = false;
  @Input() tenantPassword: string = '';
  AssetTypes = AssetType;
  getShortDateFormat = getShortDateFormat;
  constructor(
    public readonly service: AssetService,
    public readonly configState: ConfigStateService
  ) {}

  formatAssetType(type: AssetType): string {
    return type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();
  }
}
